import Box from '@zenbusiness/zui/Box';
import { styled } from '@zenbusiness/zui/styles';

/**
 * the number in the style name indicates the start column and span of the item on desktop
 * for example, ImageItemStyle23 means the item starts at column 2 and spans 3 columns on desktop
 */

export const ContentItem66 = styled(Box, { shouldForwardProp: (prop) => prop !== 'withoutImage' })(
  ({ theme, withoutImage }) => ({
    width: '100%',

    gridColumn: '1 / span 4',

    [theme.breakpoints.up('sm')]: {
      gridColumn: '2 / span 4'
    },

    [theme.breakpoints.up('md')]: {
      gridColumn: withoutImage ? '4 / span 6' : '7 / span 5'
    },

    [theme.breakpoints.up('lg')]: {
      gridColumn: withoutImage ? '4 / span 6' : '7 / span 5'
    }
  })
);

export const PageFocusItem = styled(Box)(({ theme }) => ({
  padding: 0,
  width: '100%',

  gridColumn: '1 / span 4',

  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / span 6'
  },

  [theme.breakpoints.up('md')]: {
    gridColumn: '1 / span 12'
  }
}));
